module.exports = __webpack_public_path__ + "media/images/map_icons/Yoga-d6c32b069c6f1e5555b57a8bfdc07f2a.svg";